import React from 'react';
import Footer from '../components/Footer';
import './ApplyDocumentInput.css';
import { FileUploader } from "react-drag-drop-files";
import API from '../API';

export default class ApplyDocumentInput extends React.Component {

    constructor() {
        super();

        this.state = {uploading: false}
    }

    render() {
        
        return <div style={{width:"100%", marginTop:(this.props.first)?0:50}}>

<p style={{color: "hsl(197, 8%, 17%)", fontWeight:700, fontSize:25, marginBottom:10}}>{this.props.label + ((this.props.file)?"  ✅":"")}</p>
{this.state.uploading && <div className='fileUploaderDiv'>
                

                    <div style={{alignItems:"center",display:"flex",flexDirection:"column"}}>
                        

                        <p style={{marginTop:20,fontSize:14, fontWeight:600}}>Dosya yükleniyor</p>
                        <p style={{fontSize:14,fontWeight:600, color:"#666f89"}}>(max 10MB)</p>
                    </div>

                    
                </div>}

                {(this.props.file != undefined && !this.state.uploading) && <div onClick={() => {
                    this.setState({uploading: true});

                    var type = this.props.type;
                    if(type == undefined) type = this.props.getVehicleId();
                    API.fetch((this.props.type != undefined)?'deletefile':'updatevehicle', {id:window.applicationId, type,ruhsat:this.props.ruhsat, side:this.props.side}).then((e) => {
                        console.log(e);
                        this.setState({uploading:false});
                        
                        this.props.onFileChange(undefined);
                    })
                }} className='fileUploaderDiv fileUploaded'>
                

                    <div style={{alignItems:"center",display:"flex",flexDirection:"column"}}>
                        

                        <p style={{marginTop:20,fontSize:14, fontWeight:600}}>{this.props.file}</p>
                        <button type='button' style={{border:"none", outline:"none", cursor:"pointer"}}><svg xmlns="http://www.w3.org/2000/svg" width="11px" height="13px" viewBox="0 0 11 13" version="1.1">
    <g id="Franchise---Final" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-5" transform="translate(-19.000000, -81.000000)" fill="#A4A8B3">
            <g id="Button" transform="translate(0.000000, 72.000000)">
                <g id="Icons-/-16px-/-trash" transform="translate(16.000000, 8.000000)">
                    <g id="icons8-delete" transform="translate(3.000000, 1.000000)">
                        <path d="M4.496094,0 C3.675781,0 3,0.675781 3,1.496094 L3,2 L0,2 L0,3 L1,3 L1,11.5 C1,12.324219 1.675781,13 2.5,13 L8.5,13 C9.324219,13 10,12.324219 10,11.5 L10,3 L11,3 L11,2 L8,2 L8,1.496094 C8,0.675781 7.324219,0 6.503906,0 L4.496094,0 Z M4.496094,1 L6.503906,1 C6.785156,1 7,1.214844 7,1.496094 L7,3 L9,3 L9,11.5 C9,11.78125 8.78125,12 8.5,12 L2.5,12 C2.21875,12 2,11.78125 2,11.5 L2,3 L4,3 L4,1.496094 C4,1.214844 4.214844,1 4.496094,1 Z M3,4 L3,11 L4,11 L4,4 L3,4 Z M5,4 L5,11 L6,11 L6,4 L5,4 Z M7,4 L7,11 L8,11 L8,4 L7,4 Z" id="Shape" fillRule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
</button>
                    </div>

                    
                </div>}
            {(!this.state.uploading && !this.props.file) && <FileUploader  handleChange={async (file) => {
                
                
                this.setState({uploading: true});
                var type = this.props.type;
                if(type == undefined) type = this.props.getVehicleId();
                API.fetch((this.props.type != undefined)?'uploadfile':'updatevehicle', {id: window.applicationId, type, file:file.name,ruhsat: this.props.ruhsat, side:this.props.side}).then(async(e) => {
                    console.log(e);
                    if(e.url) {
                        // let formData = new FormData()
                        // formData.append('file', file);
                        
                        // const response = await fetch(e.url, {method: "PUT", body: formData,headers: {
                        //         "Content-Type":"multipart/form-data"
                        // }});

                        let formData = new FormData()
                        formData.append('file', file);
                        console.log(file);
                        const response = await fetch(e.url, {method: "PUT", body: file,headers: {
                                "Content-Type":"multipart/form-data"
                        }});
                        console.log(response);
                        this.props.onFileChange(file.name);
                        this.setState({uploading: false});

                        
                    } else {
                        this.setState({uploading: false});
                    }
                })
                
                
            }} minSize={0} maxSize={16} multiple={false}>

                
                <div className='fileUploaderDiv'>
                {(!this.state.uploading && !this.state.file) && <div style={{alignItems:"center",display:"flex",flexDirection:"column"}}>
                        <div className='dragClass'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                                    <path d="M8.5 11.5V.5M13.5 5.5l-5-5-5 5M15.5 15.5h-14"></path>
                                </g>
                            </svg>

                            
                        </div>

                        <p style={{marginTop:20,fontSize:14, fontWeight:600}}>Bir dosya seçmek için tıklayın veya sürükleyin</p>
                        <p style={{fontSize:14,fontWeight:600, color:"#666f89"}}>(max 10MB)</p>
                    </div>}

                    {this.state.uploading && <div style={{alignItems:"center",display:"flex",flexDirection:"column"}}>
                        

                        <p style={{marginTop:20,fontSize:14, fontWeight:600}}>Dosya yükleniyor</p>
                        <p style={{fontSize:14,fontWeight:600, color:"#666f89"}}>(max 10MB)</p>
                    </div>}

                    {this.state.file && <div style={{alignItems:"center",display:"flex",flexDirection:"column"}}>
                        

                        <p style={{marginTop:20,fontSize:14, fontWeight:600}}>{this.state.file}</p>
                        <p style={{fontSize:14,fontWeight:600, color:"#666f89"}}>(max 10MB)</p>
                    </div>}
                </div>
            </FileUploader>}

           
        </div>
    }

}